import { render, staticRenderFns } from "./EnvelopeSingleClickActions.vue?vue&type=template&id=7ecef50e&scoped=true"
import script from "./EnvelopeSingleClickActions.vue?vue&type=script&lang=js"
export * from "./EnvelopeSingleClickActions.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeSingleClickActions.vue?vue&type=style&index=0&id=7ecef50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecef50e",
  null
  
)

export default component.exports